export enum ReminderNotificationTriggerActionType {
  REFERENCE_TIMESTAMP = 'REFERENCE_TIMESTAMP',
  WINDOW_END = 'WINDOW_END',
  WINDOW_START = 'WINDOW_START',
}
